import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'db0027',
    ecrans: ['00-2']
});
